import {Injectable} from '@angular/core';
import {AwsRum, AwsRumConfig} from 'aws-rum-web';
import {TelemetryEnum} from 'aws-rum-web/dist/cjs/orchestration/Orchestration';
import {environment} from '../../../../environments/environment';
import {IAnalyticsService} from './ianalyticsservice';
import {NoOpAnalyticsService} from './noop-analytics.service';

@Injectable({providedIn: 'root'})
export class AwsRumService {
  static INFO_EVENT_TYPE = 'INFO';
  static ERROR_EVENT_TYPE = 'ERROR';

  private awsRum: IAnalyticsService;

  constructor() {
  }

  init(): void {
    if (environment.enableAnalytics) {
      this.initialiseAwsRum();
    } else {
      this.awsRum = NoOpAnalyticsService;
    }
  }

  /**
   * Records a custom event in AWS RUM
   *
   * @param componentName can be found using this.constructor.name
   * @param url can be found using this.router.url (private router: Router)
   */
  // TODO: As this evolves how do we use it? Do optionals need to be optional? Do others need to be optional?
  // Could interactions be always sent, but null
  recordEventInteraction(eventType: string, componentName: string, url: string, interaction?: any): void {
    // eventType = AwsRumService.safeEventType(eventType) ?? AwsRumService.INFO_EVENT_TYPE; // TODO: Bring back in when upto Angular 14 - Needs ES2021.string

    const eventData: any = {
      srcComponent: componentName,
      url: url,
    };
    if (interaction)
      eventData.user_interaction = interaction;
    this.awsRum.recordEvent(eventType, eventData);
  }

  recordError(error: any) {
    this.awsRum.recordError(error);
  }

  private initialiseAwsRum(): void {
    try {
      const config: AwsRumConfig = {
        sessionSampleRate: 1,
        guestRoleArn: environment.guestRoleArn,
        identityPoolId: environment.identityPoolId,
        endpoint: 'https://dataplane.rum.eu-west-1.amazonaws.com',
        telemetries: [TelemetryEnum.Performance, TelemetryEnum.Errors, TelemetryEnum.Http],
        allowCookies: true,
        enableXRay: false
      };

      const APPLICATION_VERSION = '1.0.0';
      const APPLICATION_REGION = 'eu-west-1';

      this.awsRum = new AwsRum(
        environment.APPLICATION_ID,
        APPLICATION_VERSION,
        APPLICATION_REGION,
        config
      );

    } catch (error) {
      // Ignore errors thrown during CloudWatch RUM web client initialization
    }
  }

  // private static safeEventType(eventType?: string): string | undefined {
  //   return eventType?.replaceAll(' ', '_');
  // }
}
